import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  max-width: 800px;
  display: flex;
  overflow-x: auto;

  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;

  h1 {
    text-align: left;
    margin-bottom: 15px;
    color: #000;
    width: 100%;
  }

  @media (max-width: 750px) {
    padding: 10px 0;
    h1 {
      text-align: left;
      font-size: 22px;
      margin-bottom: 15px;
    }
  }

  .input {
    max-width: 390px;
    margin-bottom: 5px;
  }
`;

export const List = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;

  img {
    width: 50px;
    height: 50px;
    border-radius: 5px;
    margin-right: 15px;
  }

  div {
    border-bottom: 2px solid #f2760a;
    padding: 10px 0;
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    margin: 10px;

    div {
      border: none;
      flex-direction: column;
      justify-content: center;
      padding: 0;
      min-width: 150px;
      margin: 0;
      width: auto;
      flex: 1;
      p {
        margin: 0px;
        font-size: 14px;
        text-align: left;
      }
    }

    button {
      padding: 6px 15px;
      border-radius: 5px;
      background-color: #f2760a;
      color: #fff;
      height: 35px;
      margin: 5px 0 5px 10px;
      max-width: 250px;
      align-items: center;
      justify-content: center;
    }
  }
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background-color: #f2760a;
  padding: 15px;
  margin: 10px 0;

  input {
    padding: 8px;
    border-radius: 5px;
    background-color: #fff;
    color: #000c;
    height: 40px;
    width: 100%;
    max-width: 400px;
    border: none;
    font-size: 16px;
  }

  button {
    padding: 6px 15px;
    border-radius: 5px;
    background-color: #fff;
    color: #f2760a;
    height: 40px;
    margin-left: 50px;
    max-width: 250px;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 671px) {
    button {
      margin: 15px 30px 0;
    }
  }
`;
